import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as watchlistActions from '../../../actions/watchlistActions';

import permissionsDecorator from '../../../decorators/permissionsDecorator';
import withComponentName from '../../../decorators/withComponentName';

import WatchlistsManageBody from './WatchlistsManageBody';

const WatchlistManagePageWrapper = (props) => {
  const dispatch = useDispatch();
  const actions = useMemo(() => (
    bindActionCreators({
      ...watchlistActions,
    }, dispatch)
  ), [dispatch]);

  const token = useSelector((state) => state.watchlistReducer.userToken);

  useEffect(() => {
    if (token) {
      actions.getWatchlists();
    } else {
      actions.guestUserWatchlists();
    }
  }, []);

  return (
    <WatchlistsManageBody manageWlPage />
  );
};

export default withComponentName((permissionsDecorator(WatchlistManagePageWrapper)));
